<!--
<doc lang="markdown">
</doc>


<style scoped lang="scss">
</style>


<template lang="pug">
</template>
-->

<script>
  // "Herança" direta, mantendo a estrutura isolada (arquivos)
  import PhoneField from '../desktop/phone-field.vue'
  export default PhoneField
</script>
